import { render, staticRenderFns } from "./OrderNowStatic.vue?vue&type=template&id=e9c7d426&scoped=true&"
import script from "./OrderNowStatic.vue?vue&type=script&lang=js&"
export * from "./OrderNowStatic.vue?vue&type=script&lang=js&"
import style0 from "./OrderNowStatic.vue?vue&type=style&index=0&id=e9c7d426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c7d426",
  null
  
)

export default component.exports